<template>
  <div class="wrap pb60">
    <div class="ticket-wrap google-iap-wrap">
      <div class="payment-wrap">
        <h2>충전할 코인 선택</h2>
        <div class="payment-table-wrap">
          <table class="payment-table">
            <caption class="blind">코인 선택 표</caption>
            <colgroup>
              <col width="100%" />
            </colgroup>
            <tbody>
              <tr v-for="product in coinProductList" :key="getValue(product, 'productid')">
                <th scope="row">
                  <div class="radio-style">
                    <input
                      type="radio"
                      class="radio-purple"
                      :id="getValue(product, 'productid')"
                      :value="getValue(product, 'productid')"
                      v-model="selectedProductId"
                      name="ch-coin"
                    /><label :for="getValue(product, 'productid')">
                        <span class="google-coin-item">
                          <span>{{ getValue(product, 'product_name') }}</span>
                          <span v-if="getValue(product, 'description') !== ''" class="bonuscoin-iap">{{getValue(product, 'description')}}</span>
                        </span>
                        <span class="google-coin-price">{{amount(product)}}원</span>
                    </label>
                  </div>
                </th>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="payment-total-box">
          <span class="payment-total-text">결제금액</span>
          <span class="payment-total-price">{{totalPrice}}원</span>
        </div>
      </div>
    </div>

    <div class="payment-noti-wrap">
      <div class="ticket-noti-wrap">
        <p class="dot-text"><span>충전한 코인의 유효기간은 5년입니다.</span></p>
        <p class="dot-text">
          <span
            >코인 충전 시 보너스로 지급되는 보너스 코인의 유효기간은 한달입니다.
          </span>
        </p>
        <p class="dot-text">
          <span
            >미사용 상품은 구매 후 7일 내 청약철회 가능하며, 법정대리인의 동의를
            받지 않은 미성년자 거래는 취소 가능합니다.</span
          >
        </p>
      </div>

      <input
        type="checkbox"
        id="payment-noti-more"
        class="noti-more-btn"
        checked
      /><label for="payment-noti-more"></label>

      <div class="ticket-noti-more">
        <p class="dot-text">
          <span
            >회원이 유료 결제 후 사용하지 않은 상품은 구매일 기준 7일 내 청약
            철회가 가능합니다.</span
          >
        </p>
        <p class="dot-text">
          <span
            >고객센터>1:1문의하기 메뉴를 통해 청약철회 의사를 표시할 수 있으며,
            접수일로부터 3영업일 이내 결제 취소 또는 현금 환불해 드립니다. 다만,
            각 호의 경우에는 결제취소처리가 불가능합니다.<br />①이벤트, 쿠폰,
            보상 등 결제수단이 무료로 지급된 경우<br />②해당 기간 내에
            사용내역이 있을 경우<br />③해당 결제수단에 따른 결제취소 가능기간을
            경과한 경우
          </span>
        </p>
        <p class="dot-text">
          <span
            >만 20세 미만의 미성년자의 유료서비스 이용은 법정대리인이 이를
            취소할 수 있습니다. (단, 결제 수단의 명의자가 성년인 경우에는 취소
            제한)</span>
        </p>
      </div>
    </div>

    <div class="btn-wrap pos-bt">
      <ul class="two-btn">
        <li><a href="#" @click.prevent="cancel" class="btn-black">취소</a></li>
        <li><a href="#" @click.prevent="purchase" class="btn-purple">구매하기</a></li>
      </ul>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { filter, get } from 'lodash'
import { amount } from '@/common/filters'
import { PRODUCT_TYPE_PRODUCT } from '@/common/constant'

export default {
  data () {
    return {
      selectedProductId: null,
      coinProductList: []
    }
  },
  methods: {
    setTermsCoinList () {
      const URL = 'https://pooq3-static-json.wavve.com/service/passlist/purchase-products-coin-google_202203.json'
      axios.get(URL).then(({ data }) => {
        this.selectedProductId = null
        this.coinProductList = get(data, '0.productgroups.0.products', [])
        this.selectedProductId = get(this.coinProductList, '0.productid', null)
      })
    },
    purchase () {
      window.Android.clickGooglePurchase(PRODUCT_TYPE_PRODUCT, this.selectedProductId)
    },
    cancel () {
      location.href = 'captvpooq://webclose'
    },
    amount (product) {
      return amount(get(product, 'amount', 0))
    },
    getValue (product, name) {
      return get(product, name, '')
    }
  },
  computed: {
    totalPrice () {
      const targetProduct = filter(this.coinProductList, coinProduct => coinProduct.productid === this.selectedProductId)
      if (targetProduct.length === 0) {
        return 0
      } else {
        return amount(get(targetProduct, '0.amount', 0))
      }
    }
  },
  created () {
    this.setTermsCoinList()
  }
}
</script>
<style>
.a11y-hidden {
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  position: absolute;
  width: 1px;
  height: 1px;
}

.bg-dark {
  background-color: #252525;
}
.payment-table-wrap.bg-dark {
  border: 1px #252525 solid;
}
.blind {
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  width: 1px;
  height: 1px;
  font-size: 0;
  line-height: 0;
}

.pb60{
  padding-bottom:60px;
}

.tar {
  text-align: right !important;
}

.dot-text {
  margin-bottom: 4px;
}
.dot-text > span:before {
  content: "";
  display: inline-block;
  position: absolute;
  top: 7px;
  left: 0;
  width: 1px;
  height: 1px;
  border: 1px #5e5e5e solid;
  border-radius: 50%;
  background-color: #5e5e5e;
}
.dot-text > span {
  display: inline-block;
  position: relative;
  width: calc(100% - 10px);
  padding-left: 7px;
  font-size: 11px;
  line-height: 16px;
  color: #5e5e5e;
}
.dot-text:last-child {
  margin-bottom: 0;
}

/*체크박스 스타일 -공통 */
.check-style input[type="checkbox"] {
  position: absolute;
  clip: rect(0, 0, 0, 0);
}
.check-style input[type="checkbox"] + label {
  position: relative;
  font-size: 12px;
  line-height: 18px;
  color: #a5a5a5;
  vertical-align: middle;
}
.check-style input[type="checkbox"] + label:before {
  content: " ";
  display: inline-block;
  width: 20px;
  height: 20px;
  margin-right: 8px;
}

/*보라색 체크박스*/
.check-style input[type="checkbox"].check-purple + label:before {
  background: #fff;
  border: 1px solid #a5a5a5;
  vertical-align: middle;
}
/*.check-style input[type="checkbox"].check-purple:focus + label:before{border:1px solid #0fe85c;}*/
.check-style input[type="checkbox"].check-purple:checked + label:before {
  background: url(../../assets/images/ticket/check-on.png) no-repeat center;
  background-size: 22px;
  border-color: #1351f9;
}

/*라디오 버튼*/
.radio-style > span {
  margin-right: 15px;
}
.radio-style input[type="radio"] {
  position: absolute;
  clip: rect(0, 0, 0, 0);
}
.radio-style input[type="radio"] + label {
  position: relative;
  font-size: 14px;
}
.radio-style input[type="radio"] + label:before {
  content: " ";
  display: inline-block;
  width: 22px;
  height: 22px;
  margin-right: 7px;
  border-radius: 50%;
  background: url(../../assets/images/ticket/radio-off.png) no-repeat center;
  background-size: 22px;
}

/*보라색 라디오 박스*/
.radio-style input[type="radio"].radio-purple + label:before {
  vertical-align: middle;
}
.radio-style input[type="radio"].radio-purple:checked + label:before {
  background: url(../../assets/images/ticket/radio-on.png) no-repeat center;
  background-size: 22px;
}

/* 버튼 */
.btn-wrap ul:after {
  content: "";
  display: block;
  clear: both;
}
.btn-wrap li {
  float: left;
}
.one-btn li {
  width: 100%;
  padding: 0 20px;
}
.two-btn li {
  width: 50%;
}
.btn-wrap a,
.btn-wrap button {
  display: block;
  width: 100%;
  height: 50px;
  line-height: 48px;
  font-size: 15px;
  letter-spacing: -0.3px;
  text-align: center;
  color: #fff;
}
.btn-black {
  background-color: #5e5e5e;
}
.btn-purple {
  background-color: #1351f9;
}
.pos-bt {
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
  z-index: 1;
}

.two-btn li a.btn-round-blank {
  width: calc(100% - 10px);
  margin-right: 5px;
}
.two-btn li a.btn-round-purple {
  width: calc(100% - 10px);
  margin-left: 5px;
}

/* 이용권 리스트 */
.ticket-wrap {
  padding: 10px 16px 40px;
}
.payment-final-text + .ticket-wrap {
  padding-top: 0;
}
.ticket-layout {
  width: 100%;
  border-radius: 4px;
  margin-bottom: 5px;
}
.ticket-layout:last-child {
  margin-bottom: 0;
}
.ticket-layout th {
  width: calc(100px - 120px);
  text-align: left;
  padding: 15px 0 15px 15px;
  font-weight: 400;
}
.ticket-layout td {
  width: 150px;
  padding: 15px 15px 15px 0;
  text-align: right;
}
.ticket-list-btn {
  text-align: left;
  padding: 20px 15% 20px 15px;
  width: 100%;
}
button.ticket-list-btn {
  background: url(../../assets/images/ticket/arrow-list-open.png) no-repeat 95%
  center;
  background-size: 30px;
}
.ticket-payment-layout {
  width: 100%;
  border: 1px #2f2f2f solid;
  border-radius: 4px;
  margin-bottom: 5px;
}
.ticket-payment-layout tr {
  border-bottom: 1px solid #e5e5e5;
}
.ticket-payment-layout tr:last-child {
  border-bottom: none;
}
.ticket-payment-layout .ticket-list-btn {
  border-bottom: 1px solid #e5e5e5;
}

.m-ticket-title {
  margin-bottom: 10px;
  font-size: 15px;
  line-height: 17px;
  color: #fff;
  font-weight: 400;
}
.payment-table-wrap .m-ticket-title {
  margin-bottom: 0;
}
.m-ticket-title > a {
  position: absolute;
  right: 0;
  font-size: 12px;
  color: #23212a;
}
.m-ticket-title img {
  width: 12px;
  margin-top: -3px;
}
.m-ticket-sub-title {
  font-size: 12px;
  line-height: 1.25em;
  color: #777;
  margin-bottom: 10px;
}
.ticket-title {
  font-weight: 700;
  font-size: 15px;
  line-height: 17px;
  color: #a5a5a5;
}
.ticket-price {
  font-weight: 700;
  font-size: 15px;
  letter-spacing: -0.3px;
}
.ticket-sale {
  display: inline-block;
  font-size: 13px;
  text-decoration: line-through;
  opacity: 0.5;
  margin-right: 5px;
  margin-top: 6px;
}
.ticket-buy-btn {
  display: inline-block;
  width: 72px;
  height: 30px;
  line-height: 30px;
  border-radius: 100px;
  text-align: center;
  font-size: 13px;
  color: #fff;
}
.ticket-layout th .ticket-buy-btn {
  margin-top: 17px;
}
.number-people {
  font-size: 0;
}
.number-people img {
  width: 32px;
}
.number-people-text01 {
  display: inline-block;
  margin: 0 20px;
  font-size: 13px;
  text-align: center;
  color: #a5a5a5;
  vertical-align: middle;
}
.number-people-text02 {
  font-size: 11px;
  text-align: center;
  color: #777;
  margin-top: 7px;
  padding-left: 20px;
}

/* 이용권 색깔 */
/* 보라색 */
.ticket-purple .ticket-price {
  color: #1351f9;
}
.ticket-purple .ticket-buy-btn {
  background-color: #1351f9;
}
.ticket-purple.ticket-list-open .ticket-list-btn-tit {
  color: #1351f9;
}
.ticket-payment-layout.ticket-purple .ticket-list-btn-tit {
  color: #1351f9;
}

/* 하늘색 */
.ticket-skyblue .ticket-price {
  color: #1da8ee;
}
.ticket-skyblue .ticket-buy-btn {
  background-color: #1da8ee;
}
.ticket-skyblue.ticket-list-open .ticket-list-btn-tit {
  color: #1da8ee;
}
.ticket-payment-layout.ticket-skyblue .ticket-list-btn-tit {
  color: #1da8ee;
}

/* 빨간색 */
.ticket-red .ticket-price {
  color: #ff3c33;
}
.ticket-red .ticket-buy-btn {
  background-color: #ff3c33;
}
.ticket-red.ticket-list-open .ticket-list-btn-tit {
  color: #ff3c33;
}
.ticket-payment-layout.ticket-red .ticket-list-btn-tit {
  color: #ff3c33;
}

/* 주의사항 */
.ticket-noti-wrap {
  margin-top: 0;
  margin-bottom: 16px;
}

/* 이용권 리스트 */
.google-iap-wrap .payment-table .radio-style input[type="radio"] + label{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.google-iap-wrap .google-coin-item{
  display: flex;
  flex-direction: column;
  flex: 1;
}
.bonuscoin-iap{
  display: block;
  font-size: 12px;
  line-height: 18px;
  color: #717171;
}
.google-iap-wrap .payment-table .radio-style input[type="radio"] + label{
  display: flex;
  flex-direction: row;
}
.google-iap-wrap .google-coin-price{
  color: #fff;
}

/* 결제하기 */
.payment-wrap {
  border-radius: 4px;
}
.payment-wrap + .payment-wrap {
  margin-top: 30px;
}
.payment-wrap h2 {
  margin-bottom: 12px;
  font-size: 16px;
  line-height: 24px;
  color: #fff;
  font-weight: 400;
}
.payment-table-wrap {
  border: 1px #2f2f2f solid;
  border-radius: 4px;
}
.payment-table {
  width: 100%;
}
.payment-table tr {
  border-bottom: 1px solid #2f2f2f;
}
.payment-table tr:last-child {
  border-bottom: none;
}
.payment-table th,
.payment-table td {
  height: 54px;
  color: #a5a5a5;
  font-size: 14px;
}
.payment-table th {
  width: 120px;
  padding: 16px 16px;
  text-align: left;
  font-weight: 400;
}
.payment-table td {
  height: 54px;
  padding: 16px 16px 16px 4px;
}
.payment-table.table-border tr {
  border-bottom: none;
}
.payment-table.table-border tr:first-child {
  border-bottom: 1px #2f2f2f solid;
}
.payment-table.table-border th {
  vertical-align: top;
}

.payment-table .ticket-title {
  margin-bottom: 4px;
}
.payment-table .em-text {
  display: block;
  font-size: 13px;
  letter-spacing: -0.2px;
  color: #a5a5a5;
  text-align: right;
}
.payment-table .ticket-price {
  font-size: 18px;
  color: #fff;
}
.payment-table .ticket-price-big {
  font-weight: 700;
  font-size: 18px;
  color: #fff;
}
.payment-event {
  margin: 5px 0 30px;
}
.payment-event img {
  width: 100%;
}
.payment-event .banner-event {
  display: none;
  width: 100%;
  height: 40px;
  background-color: #1b1b1b;
  outline: none;
  font-size: 14px;
  line-height: 40px;
  color: #a5a5a5;
  text-align: center;
}
.event-close:after,
.event-open:after {
  content: "";
  display: inline-block;
  width: 12px;
  height: 12px;
  margin-left: 4px;
  vertical-align: middle;
}
.event-close:after {
  background: url(../../assets/images/icon-close.png) no-repeat #1b1b1b;
  background-size: 12px 12px;
}
.event-open:after {
  background: url(../../assets/images/icon-open.png) no-repeat #1b1b1b;
  background-size: 12px 12px;
}
.event-exclamation {
  padding: 10px 0;
  background-color: #1b1b1b;
  font-size: 12px;
  line-height: 18px;
  color: #5e5e5e;
}
.event-open + .event-exclamation {
  display: none;
}
.event-close + .event-exclamation {
  display: block;
}
.event-exclamation li {
  position: relative;
  margin-bottom: 4px;
  padding-left: 7px;
}
.event-exclamation li:before {
  content: "";
  position: absolute;
  top: 7px;
  width: 1px;
  height: 1px;
  margin-left: -4px;
  background-color: #5e5e5e;
  border-radius: 50%;
}

.payment-table .radio-style input[type="radio"] + label {
  font-size: 13px;
  color: #a5a5a5;
}
.payment-table .radio-style input[type="radio"] + label:before {
  margin-right: 14px !important;
}

.payment-check .check-style {
  margin: 18px 0;
}
.payment-check .check-style input[type="checkbox"].check-purple + label:before {
  background-color: transparent;
}
.payment-check label > span {
  display: inline-block;
  width: calc(100% - 40px);
  vertical-align: middle;
}

.payment-noti-wrap {
  padding: 0 16px;
}
.payment-noti-wrap:after {
  display: block;
  clear: both;
  content: "";
}

.noti-more-btn {
  position: absolute;
  z-index: 9;
  right: 10px;
  width: 18px;
  height: 18px;
  opacity: 0;
  outline: 0;
  -webkit-appearance: none;
}

.noti-more-btn ~ label {
  float: right;
  padding-right: 22px;
  margin-bottom: 10px;
  font-size: 12px;
  line-height: 18px;
  color: #a5a5a5;
  /*background-image: url(../../assets/images/ticket/arrow-open.png);*/
  background-repeat: no-repeat;
  background-position: right 4px center;
  background-size: 12px;
}
.noti-more-btn ~ label:before {
  content: "자세히보기";
}
.ticket-noti-more {
  display: none;
  margin-top: 20px;
}
.noti-more-btn:checked ~ .ticket-noti-more {
  display: block;
}
.noti-more-btn:checked ~ label {
  /*background-image: url(../../assets/images/ticket/arrow-close.png);*/
  background-size: 12px;
}
.noti-more-btn:checked ~ label:before {
  content: "닫기";
}
form[action="/ProductCoin"] {
  visibility: hidden;
}

/* payco 최종 */
.payment-total {
  border-radius: 4px;
  padding: 18px 15px;
  background-color: #252525;
}
.payment-wrap + .payment-total {
  margin-top: 30px;
}
.payment-total > p {
  font-size: 0;
}
.payment-total > p:after {
  content: "";
  display: block;
  clear: both;
}
.payment-total > p + p {
  margin-top: 16px;
}
.payment-total span {
  font-size: 13px;
  line-height: 18px;
  color: #a5a5a5;
}
.payment-total .sale-price {
  float: right;
  font-size: 13px;
  color: #a5a5a5;
}
.payment-total .total-price {
  float: right;
  font-weight: 700;
  font-size: 16px;
  color: #fff;
}

/* 결제수단 변경 */
.defend-wrap {
  width: 100%;
  background: #252525;
  position: relative;
}
.defend-wrap h1 {
  font-size: 20px;
  line-height: 29px;
  color: #fff;
}
.defend-wrap .defend-close {
  position: absolute;
  top: 8px;
  right: 8px;
}
.defend-wrap .defend-close > img {
  width: 24px;
  height: 24px;
}
.defend-wrap .defend-contents {
  padding: 30px 20px 20px;
  overflow: hidden;
}
.defend-wrap .defend-type01 {
  padding-top: 40px;
}
.defend-wrap .con-tit {
  font-size: 13px;
  font-weight: 700;
  margin: 0 0 10px;
  display: block;
  color: #23212a;
  line-height: 1.5;
}
.defend-wrap .con-dotted {
  display: block;
  font-size: 13px;
  line-height: 1.38;
  padding-left: 9px;
  text-indent: -9px;
}
.defend-wrap .con-dotted em {
  display: inline-block;
  background: #5e5e5e;
  width: 2px;
  height: 2px;
  vertical-align: middle;
  margin-right: 4px;
}
.table-select {
  width: 100%;
  height: 47px;
  line-height: 47px;
  border-radius: 5px;
  border: solid 1px #2f2f2f;
  padding: 0 15px;
  font-size: 14px;
  color: #a5a5a5;
  background: url(../../assets/images/ticket/ic-input-down.png) #2f2f2f
  no-repeat right center;
  background-size: 36px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.payment-input input[type="text"] {
  width: 100%;
  height: 47px;
  line-height: 47px;
  border-radius: 5px;
  border: solid 1px #2f2f2f;
  background-color: #2f2f2f;
  padding: 0 15px;
  font-size: 14px;
  color: #a5a5a5;
}

.payment-table.table-border .total-bt th {
  vertical-align: middle;
}

/* 결제 금액 */
.payment-total-box{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  padding: 18px 16px;
  border-radius: 4px;
  background-color: #252525;
}
.payment-total-text{
  font-size: 14px;
  line-height: 20px;
  color: #a5a5a5;
}
.payment-total-price{
  font-size: 16px;
  line-height: 24px;
  color: #fff;
}
</style>
